import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { FORCED_NAV } from './forced-nav';
import { LogoutService } from './logout.service';

export const authInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (isStaticAsset(req)) {
    return next(req);
  }

  const logout = inject(LogoutService);
  const router = inject(Router);

  return next(withJsonHeaders(req)).pipe(
    catchError((error: unknown) => {
      handleHttpError(error, logout, router);
      return throwError(() => error);
    })
  );
};

function isStaticAsset(req: HttpRequest<unknown>): boolean {
  return req.url.endsWith('.html') || req.url.endsWith('.htm');
}

function withJsonHeaders(req: HttpRequest<unknown>): HttpRequest<unknown> {
  const headers: Record<string, string> = { Accept: 'application/json' };

  if (!(req.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  return req.clone({ setHeaders: headers, withCredentials: true });
}

function handleHttpError(
  error: unknown,
  logout: LogoutService,
  router: Router
): void {
  if (!(error instanceof HttpErrorResponse)) {
    return;
  }

  switch (error.status) {
    case 401:
      logout.logout();
      return;
    case 404:
      router.navigate(['authentication/error404'], FORCED_NAV);
      return;
    case 0:
    case 500:
      router.navigate(['authentication/maintenance'], FORCED_NAV);
      return;
  }
}
